import { render, staticRenderFns } from "./WizardStep2.vue?vue&type=template&id=c613adda&scoped=true"
import script from "./WizardStep2.vue?vue&type=script&lang=js"
export * from "./WizardStep2.vue?vue&type=script&lang=js"
import style0 from "./WizardStep2.vue?vue&type=style&index=0&id=c613adda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c613adda",
  null
  
)

export default component.exports